import styled from 'styled-components';

import { media } from '@/utils';

import { AI_CHAT_GAP, AI_CHAT_WIDTH } from '../AiChatSidebar';

/** Prawy margines treści: szerokość czatu z odstępem minus margines kontenera (Main ma już --hs-gutter). */
const chatShift = (chatOpen: boolean): string => (
  chatOpen ? `max(0px, calc(${AI_CHAT_WIDTH + AI_CHAT_GAP}px - var(--hs-gutter, 0px)))` : '0'
);

/*
 * Przy otwartym czacie treść formularza zwęża się o szerokość szuflady (kolumna obok czatu),
 * żeby czat nigdy nie zasłaniał pól ani przycisku Zapisz. Od 1200 px (desktop, siatka z menu
 * po lewej) zawsze przesuwamy; poniżej (tablet, telefon) szuflada nakłada się na treść jak
 * dotąd, bo obok formularza nie ma na nią miejsca.
 */
export const ContentShift = styled.div<{ $chatOpen: boolean }>`
  transition: padding-right 0.2s ease;

  ${media.desktop} {
    padding-right: ${({ $chatOpen }) => chatShift($chatOpen)};
  }

  ${media.reducedMotion} {
    transition: none;
  }
`;
